var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',{staticClass:"layout-3"},[_c('Header',{attrs:{"flag":_vm.flag & 4}}),_c('a-layout',[_c('Sidebar',{attrs:{"flag":_vm.flag & 129}}),_c('a-layout',[_c('Nav',{attrs:{"flag":_vm.flag & 6}}),_c('Content')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }